import { CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Printer, Mail, Download } from 'lucide-react';

interface PayslipHeaderProps {
  onDownload: () => void;
  onPrint: () => void;
  onEmail: () => void;
}

export const PayslipHeader = ({ onDownload, onPrint, onEmail }: PayslipHeaderProps) => {
  return (
    <CardHeader className="flex flex-row items-center justify-between pb-2 pt-6">
      <CardTitle className="text-xl">Payslip Details</CardTitle>
      <div className="flex space-x-2">
        <Button size="sm" variant="outline" onClick={onPrint}>
          <Printer className="h-4 w-4 mr-1" />
          Print
        </Button>
        <Button size="sm" variant="outline" onClick={onEmail}>
          <Mail className="h-4 w-4 mr-1" />
          Email
        </Button>
        <Button size="sm" onClick={onDownload}>
          <Download className="h-4 w-4 mr-1" />
          Download
        </Button>
      </div>
    </CardHeader>
  );
};